import { Component, OnInit } from '@angular/core';
import { BillersService } from '../../../services/billers.service'
import { AuthService } from 'src/app/services/auth.service';
import { SendMoneyService } from '../../send-money/send-money.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-biller2',
  templateUrl: './biller2.component.html',
  styleUrls: ['./biller2.component.scss']
})
export class Biller2Component implements OnInit {

  options
  gateway_fees: number
  amountWithGatewayFees: number
  celoData: any = {
    data: {},
    paymentSelectedoption: {
      payment_id: null,
      payment_gateways_id: null
    },
    celoWalletNumber: ""
  };
  constructor(public billerService: BillersService, public auth: AuthService, public sendMoney: SendMoneyService, public router: Router) { }

  ngOnInit(): void {

    console.log("Biller2Component ngOnInit called");

    this.billerService.common.showLoader()
    setTimeout(() => {
      this.amountWithGatewayFees =
        +this.billerService.finalData['amount_cad'] +
        +this.billerService.finalData['transaction_fees']
    }, 2000)
    this.billerService.details = true
    this.billerService.confirm = false
    this.sendMoney.getcaPaymentOptions().subscribe(res => {
      //console.log(res)
      this.options = res['data']
      //console.log(this.options)
      this.billerService.common.stopLoader()
    })
    console.log("this.billerService.biller");
    console.log(this.billerService.biller);
  }

  special_char(event) {
    var k;
    k = event.charCode;  // k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  // selectBiller(biller) {
  //   this.selectedBiller = biller;
  //   this.billerService.biller = this.selectedBiller;
  //   webengage.track('biller_select', {
  //     country: biller.country_name,
  //     biller: biller.biller_name
  //   })
  // }

  onSelectPaymentMethod(method) {
    console.log('click onSelectCAPaymentMethod', method);
    this.sendMoney.selectedCAPaymentMethod = method
    this.billerService.paymentMethod = method
    this.gateway_fees = method.gateway_fee
    //console.log(method.gateway_fee_type)
    console.log("this.sendMoney.selectedCAPaymentMethod.payment_gateways_id");
    console.log(this.sendMoney.selectedCAPaymentMethod.payment_gateways_id, this.billerService.finalData['biller_amount_local']);

    if (this.sendMoney.selectedCAPaymentMethod.payment_gateways_id == 6) {
      //console.log("getCeloBillAmount api call hua");
      this.billerService
        .getBillAmount(
          this.billerService.biller.currency,
          this.billerService.finalData['biller_amount_local'],
          method.payment_id
        )
        .subscribe(
          (data) => {
            console.log("Happy with Patience");
            console.log(data, method.payment_id);
            if (method.payment_id == 6) {
              this.celoData.paymentSelectedoption.payment_id = method.payment_id;
              this.celoData.paymentSelectedoption.payment_gateways_id = method.payment_id;
              this.celoData.data = data;
              console.log(this.celoData);
            }

          }, (error) => {
            console.log("error caught caught");
            console.log(error);
          })
    } else {

      this.celoData.paymentSelectedoption.payment_id = method.payment_id;
      this.celoData.paymentSelectedoption.payment_gateways_id = method.payment_id;
    }

    if (!method.gateway_fee_type) {
      this.amountWithGatewayFees =
        +this.billerService.finalData['amount_cad'] +
        +this.billerService.finalData['transaction_fees'] +
        +method.gateway_fee
    }
    else {
      this.amountWithGatewayFees =
        +((+this.billerService.finalData['amount_cad'] +
          +this.billerService.finalData['transaction_fees']) * (1 + (+method.gateway_fee) / 100)).toFixed(2)
    }

  }

  checkAndProceed() {
    this.billerService.finalData = {
      ...this.billerService.finalData,
      ...{
        gateway_fees: this.gateway_fees,
        total_amount: this.amountWithGatewayFees,
        new_trans_fee: 0,
        celoData: this.celoData
      }
    }
    //console.log(this.billerService.finalData)
    this.billerService.nextPage('biller3')
  }
}
